import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MensagemPaginaErro } from 'src/app/utils/mensagens.pagina.erro';


@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  @Input() public messageError = "";
  @Input() public textConfirm = 'Página Inicial';
  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
      this.messageError = MensagemPaginaErro.mensagemRetornoPaginaErro(sessionStorage.getItem('idErro')!);
  }


  public handleOnConfirm() {
    this.router.navigate(["/conheca-seus-direitos"]);
  }
}
